/**
 * SR26 · Recensioner — egen rendering mot skinroller-reviews-workern.
 * Figma: board 1308:6, block 13.
 */
(function () {
  'use strict';

  var SEC = document.querySelector('[data-sr26-reviews]');
  if (!SEC || SEC.dataset.rvInit) return;
  SEC.dataset.rvInit = '1';

  var API = SEC.dataset.api.replace(/\/$/, '');
  var SKU = SEC.dataset.sku;
  var PER = parseInt(SEC.dataset.perPage, 10) || 5;
  var ONLY_THIS = SEC.dataset.onlyThis === 'true';

  var asideEl = SEC.querySelector('[data-rv-aside]');
  var listEl = SEC.querySelector('[data-rv-list]');
  var moreEl = SEC.querySelector('[data-rv-more]');
  var moreBtn = SEC.querySelector('[data-rv-more-btn]');
  var countEl = SEC.querySelector('[data-rv-count]');
  var toolbarEl = SEC.querySelector('[data-rv-toolbar]');
  var summaryEl = SEC.querySelector('[data-rv-summary]');

  var state = { page: 1, sort: 'best', attrs: {}, subs: {}, minRating: 1, loading: false, total: 0, data: null };

  function esc(s) {
    return String(s == null ? '' : s).replace(/[&<>"']/g, function (c) {
      return { '&': '&amp;', '<': '&lt;', '>': '&gt;', '"': '&quot;', "'": '&#39;' }[c];
    });
  }

  function stars(n) {
    var out = '';
    for (var i = 1; i <= 5; i++) {
      out += '<span class="sr26-rv__star' + (i <= Math.round(n) ? ' is-on' : '') + '">★</span>';
    }
    return '<span class="sr26-rv__stars" aria-label="' + n.toFixed(1) + ' av 5">' + out + '</span>';
  }

  // "2026-07-10 09:04:35" → "4 mån sedan". Absoluta datum säger ingenting om
  // en recension är färsk; det relativa är hela informationen.
  // Texterna kommer från språkfilerna via snippets/sr26-i18n.liquid.
  // Svenskan efter || är bara reserv om snippeten saknas.
  function T(k, fb, vars) {
    var s = ((window.sr26I18n || {})[k]) || fb;
    if (vars) Object.keys(vars).forEach(function (v) { s = s.split('{{ ' + v + ' }}').join(vars[v]); });
    return s;
  }

  function ago(iso) {
    var d = new Date(String(iso).replace(' ', 'T') + 'Z');
    if (isNaN(d)) return '';
    var days = Math.floor((Date.now() - d.getTime()) / 86400000);
    if (days < 1) return T('rv_today', 'i dag');
    if (days < 30) return T('rv_days_ago', '{{ n }} dagar sedan', { n: days });
    var m = Math.floor(days / 30);
    if (m < 12) return T('rv_months_ago', '{{ n }} mån sedan', { n: m });
    var y = Math.floor(m / 12);
    return T('rv_years_ago', '{{ n }} år sedan', { n: y });
  }

  function params(extra) {
    var p = new URLSearchParams();
    p.set('sku', SKU);
    p.set('per_page', String(PER));
    p.set('page', String(state.page));
    p.set('sort', state.sort);
    if (ONLY_THIS) p.set('only_this', '1');

    var attr = [];
    Object.keys(state.attrs).forEach(function (id) {
      state.attrs[id].forEach(function (v) { attr.push(id + ':' + v); });
    });
    if (attr.length) p.set('attr', attr.join(','));

    var sub = [];
    Object.keys(state.subs).forEach(function (id) {
      state.subs[id].forEach(function (v) { sub.push(id + ':' + v); });
    });
    if (sub.length) p.set('sub', sub.join(','));
    if (state.minRating > 1) p.set('min_rating', String(state.minRating));

    Object.keys(extra || {}).forEach(function (k) { p.set(k, extra[k]); });
    return p.toString();
  }

  // Avatartonen följer "Recensionskort · beslutat system": tio dova toner som
  // cyklar per initial. Bokstaven avgör tonen, inte slumpen — samma namn får
  // alltid samma färg, även mellan sidladdningar.
  function avatarTone(name) {
    var c = (name || 'A').charAt(0).toUpperCase().charCodeAt(0) - 65;
    return ((c % 10) + 10) % 10;
  }

  function reviewHtml(r) {
    // Attributraden: "40–49 · Pigmentfläckar". Etiketterna utelämnas — värdena
    // säger sig själva och raden ska läsas som en signatur, inte en tabell.
    var vals = (r.attributes || []).map(function (a) { return a.value; }).filter(Boolean);
    var badge = (r.subratings || [])[0];
    var initial = (r.author || 'A').charAt(0).toUpperCase();

    return (
      '<article class="sr26-rv__item">' +
        '<span class="sr26-rv__avatar" data-tone="' + avatarTone(r.author) + '" aria-hidden="true">' + esc(initial) + '</span>' +
        '<div class="sr26-rv__body">' +
        '<header class="sr26-rv__head">' +
          '<span class="sr26-rv__author">' + esc(r.author) + '</span>' +
          (r.verified
            ? '<span class="sr26-rv__verified">' +
                // Bock i en sigill-form, inte en prick. En prick säger att
                // något är sant; bocken säger vad — att köpet är kontrollerat.
                '<svg class="sr26-rv__check" viewBox="0 0 20 20" aria-hidden="true">' +
                  '<path fill="currentColor" d="M10 .8l2.2 1.9 2.9-.3 1 2.7 2.7 1-.3 2.9L20 10l-1.5 2.2.3 2.9-2.7 1-1 2.7-2.9-.3L10 19.2l-2.2-1.9-2.9.3-1-2.7-2.7-1 .3-2.9L0 10l1.5-2.2-.3-2.9 2.7-1 1-2.7 2.9.3z"/>' +
                  '<path fill="#fff" d="M8.9 13.4L5.6 10.1l1.3-1.3 2 2 4.2-4.2 1.3 1.3z"/>' +
                '</svg>' + esc(T('rv_verified', 'Verifierad')) + '</span>'
            : '') +
          '<time class="sr26-rv__date">' + esc(ago(r.date)) + '</time>' +
        '</header>' +
        (vals.length || badge
          ? '<p class="sr26-rv__meta">' +
              (vals.length ? esc(vals.join(' · ')) : '') +
              (badge ? '<span class="sr26-rv__badge">' + esc(badge.text) + ' ' + esc(T('rv_difference', 'skillnad')) + '</span>' : '') +
            '</p>'
          : '') +
        stars(r.rating) +
        '<p class="sr26-rv__text">' + esc(r.text) + '</p>' +
        ((r.replies || []).length
          ? '<div class="sr26-rv__reply"><span>' + esc(T('rv_replied', 'Skinroller svarade')) + '</span><p>' +
              esc(r.replies[0].text) + '</p></div>'
          : '') +
        '</div>' +
      '</article>'
    );
  }

  // Fyllnaden skalas mot den STÖRSTA stapeln, inte mot totalen: 74 % av
  // alla betyg ÄR dominant och ska läsas så — en 74 %-fyllnad ser halvtom
  // ut. Procentetiketten fortsätter räknas mot totalen och talar sanning.
  function bar(label, n, total, maxN) {
    var pct = total ? Math.round((n / total) * 100) : 0;
    var fill = maxN ? Math.round((n / maxN) * 100) : 0;
    return (
      '<div class="sr26-rv__bar-row">' +
        '<span class="sr26-rv__bar-n">' + label + '</span>' +
        '<span class="sr26-rv__bar"><span class="sr26-rv__bar-fill" style="width:' + fill + '%"></span></span>' +
        '<span class="sr26-rv__bar-pct">' + pct + ' %</span>' +
      '</div>'
    );
  }

  function chipsHtml(kind, id, label, values, active, note) {
    var items = Object.keys(values).sort(function (a, b) { return values[b] - values[a]; });
    if (!items.length) return '';
    return (
      '<div class="sr26-rv__group">' +
        '<p class="sr26-rv__group-title">' + esc(label) + '</p>' +
        (note ? '<p class="sr26-rv__group-note">' + esc(note) + '</p>' : '') +
        '<div class="sr26-rv__chips">' +
          items.map(function (v) {
            var on = active.indexOf(v.toLowerCase()) !== -1;
            return (
              '<button type="button" class="sr26-rv__chip' + (on ? ' is-on' : '') + '"' +
                ' data-rv-chip="' + kind + '" data-id="' + esc(id) + '" data-value="' + esc(v) + '">' +
                esc(v) + '<span class="sr26-rv__chip-n">' + values[v] + '</span>' +
              '</button>'
            );
          }).join('') +
        '</div>' +
      '</div>'
    );
  }

  function renderAside(d) {
    var s = d.stats;
    var h = s.histogram || {};
    var totalRatings = [1, 2, 3, 4, 5].reduce(function (a, k) { return a + (h[k] || 0); }, 0);

    var facets = d.facets || {};
    var chips = '';
    Object.keys(facets).forEach(function (key) {
      var f = facets[key];

      // Ett filter med ett enda alternativ kan inte smalna av något — det
      // enda det gör är att gömma resten. Delbetyget hade en (1) ifylld
      // recension av 391 och tog en hel rubrik i anspråk för det.
      var values = Object.keys(f.values);
      var covered = values.reduce(function (a, v) { return a + f.values[v]; }, 0);
      if (values.length < 2 || covered < 10) return;

      var isSub = key.indexOf('sub:') === 0;
      var id = isSub ? key.slice(4) : key;
      var active = (isSub ? state.subs[id] : state.attrs[id]) || [];
      // "Vilken hudtyp har du?" innehåller i praktiken hudproblem. Rubriken
      // följer datan, inte frågan — annars lovar den något annat.
      var isSkin = /hudtyp/i.test(f.label);
      var label = isSkin ? T('rv_skin_concerns', 'Hudproblem') : f.label;
      // Attributet är frivilligt i formuläret, så filtret når bara den del
      // av recensionerna som svarat. Utan den upplysningen läser ett tomt
      // resultat som en bugg i stället för som saknad data.
      var note = isSkin ? T('rv_optional_note', 'Tillgängligt om recensenten angivit') : '';
      chips += chipsHtml(isSub ? 'sub' : 'attr', id, label, f.values, active, note);
    });

    var anyFilter = Object.keys(state.attrs).length || Object.keys(state.subs).length || state.minRating > 1;

    // Betyget är en skala, inte en kategori — kunden vill se "4 och uppåt",
    // inte exakt 4. Därför spak i stället för fem chips. Fyllnaden går från
    // tummen till höger: det valda intervallet, inte ett värde.
    var mr = state.minRating;
    var sliderPct = ((mr - 1) / 4) * 100;
    var ratingGroup =
      '<div class="sr26-rv__group sr26-rv__group--rating">' +
        '<p class="sr26-rv__group-title">' + esc(T('rv_rating', 'Betyg')) +
          '<span class="sr26-rv__rating-value" data-rv-rating-value>' +
            (mr > 1 ? esc(T('rv_at_least', 'Minst')) + ' ' + '★'.repeat(mr) : esc(T('rv_all', 'Alla'))) +
          '</span>' +
        '</p>' +
        '<input type="range" class="sr26-rv__slider" min="1" max="5" step="1" value="' + mr + '"' +
          ' style="--pct:' + sliderPct + '%"' +
          ' aria-label="' + esc(T('rv_lowest_rating', 'Lägsta betyg')) + '" data-rv-minrating>' +
        '<div class="sr26-rv__slider-scale" aria-hidden="true">' +
          [1, 2, 3, 4, 5].map(function (n) { return '<span>' + n + ' ★</span>'; }).join('') +
        '</div>' +
      '</div>';

    // Bandet räknas ur SAMMA avrundade tal som staplarna visar, inte ur
    // workerns pct_4_5. Workern summerar de exakta andelarna och avrundar
    // sist (74,3 + 20,4 = 94,7 → 95), medan staplarna avrundar var för sig
    // (74 + 20 = 94). Båda är korrekta, men på samma skärm läser det som
    // ett räknefel — och kunden litar hellre på det hon kan kontrollera.
    var band4_5 = null;
    if (totalRatings) {
      band4_5 = Math.round(((h[5] || 0) / totalRatings) * 100) +
                Math.round(((h[4] || 0) / totalRatings) * 100);
    } else if (s.pct_4_5 != null) {
      band4_5 = s.pct_4_5;
    }

    if (summaryEl) summaryEl.innerHTML =
      '<div class="sr26-rv__summary">' +
        '<div class="sr26-rv__score">' +
          '<span class="sr26-rv__avg">' + (s.average ? s.average.toFixed(2).replace('.', ',') : '–') + '</span>' +
          '<span class="sr26-rv__score-meta">' + stars(s.average || 0) +
            '<span class="sr26-rv__total">' + esc(T('rv_count', '{{ n }} recensioner', { n: s.group_total })) + '</span>' +
          '</span>' +
        '</div>' +
        '<div class="sr26-rv__bars">' +
          (function () {
            var maxN = Math.max(h[1] || 0, h[2] || 0, h[3] || 0, h[4] || 0, h[5] || 0);
            return [5, 4, 3, 2, 1].map(function (k) { return bar(k, h[k] || 0, totalRatings, maxN); }).join('');
          })() +
        '</div>' +
      '</div>' +
      (band4_5 != null
        ? '<p class="sr26-rv__band"><strong>' + band4_5 + ' %</strong> ' + esc(T('rv_band', 'gav fyra eller fem stjärnor')) + '</p>'
        : '');

    // Teasern högre upp på sidan ("Vad säger kunderna?") behöver samma
    // andel. Den siffran finns bara här — ett eget anrop till workern skulle
    // hämta identisk data en gång till, så den skickas vidare i stället.
    // Teasern ska visa exakt samma siffra som bandet, alltså den
    // stapelavstämda — inte workerns.
    var statsOut = {};
    for (var kk in s) { if (Object.prototype.hasOwnProperty.call(s, kk)) statsOut[kk] = s[kk]; }
    if (band4_5 != null) statsOut.pct_4_5 = band4_5;
    document.dispatchEvent(new CustomEvent('sr26:reviews-stats', { detail: statsOut }));

    asideEl.innerHTML =
      '<div class="sr26-rv__filters">' +
        '<p class="sr26-rv__filters-title">' + esc(T('rv_filter', 'Filtrera')) + '</p>' +
        ratingGroup +
        chips +
        // Utan filter är raden bara ett eko av toolbarens "N av M" — den
        // förtjänar plats först när den säger något eget: vad filtret gav.
        (anyFilter
          ? '<p class="sr26-rv__result">' + esc(T('rv_matching', '{{ n }} recensioner matchar', { n: s.shown_total })) +
            ' <button type="button" class="sr26-rv__clear" data-rv-clear>' + esc(T('rv_clear', 'Rensa')) + '</button></p>'
          : '') +
      '</div>';

    // Sorteringen hör till listan, inte till filtren — den ändrar ordning,
    // aldrig urval. Därför bor den i toolbaren ovanför korten.
    if (toolbarEl) {
      toolbarEl.hidden = false;
      // Räknaren visas bara när ett filter är aktivt — ofiltrerad säger den
      // inget som inte asiden och "Visar N av M" redan säger, och tre olika
      // nämnare samtidigt läser som en bugg.
      var filterCount = Object.keys(state.attrs).reduce(function (a, k) { return a + state.attrs[k].length; }, 0) +
        Object.keys(state.subs).reduce(function (a, k) { return a + state.subs[k].length; }, 0) +
        (state.minRating > 1 ? 1 : 0);
      toolbarEl.innerHTML =
        (anyFilter
          ? '<span class="sr26-rv__toolbar-count">' + esc(T('rv_x_of_y', '{{ x }} av {{ y }} recensioner', { x: s.shown_total, y: s.group_total })) + '</span>' +
            '<span class="sr26-rv__toolbar-sep">·</span>'
          : '') +
        '<label class="sr26-rv__toolbar-label" for="sr26-rv-sort">' + esc(T('rv_sort', 'Sortera')) + '</label>' +
        '<select class="sr26-rv__sort-select" id="sr26-rv-sort" data-rv-sort-select>' +
          [['best', T('rv_sort_best', 'Utvalda')], ['recent', T('rv_sort_recent', 'Nyast')], ['highest', T('rv_sort_highest', 'Högst betyg')], ['lowest', T('rv_sort_lowest', 'Lägst betyg')]]
            .map(function (o) {
              return '<option value="' + o[0] + '"' + (state.sort === o[0] ? ' selected' : '') + '>' + esc(o[1]) + '</option>';
            }).join('') +
        '</select>' +
        // Mobilens väg in till filtren. Samma knapp som kollektionerna
        // använder: temats .button + .filter-toggle-button med skjutreglage-
        // ikonen, så den svarta pillen och ikonen kommer från temat i stället
        // för att ritas om här.
        '<button type="button" class="button filter-toggle-button sr26-rv__filter-btn"' +
          ' data-rv-filter-open aria-haspopup="dialog">' +
          '<svg width="24" height="24" viewBox="0 0 24 24" fill="currentColor" aria-hidden="true">' +
            '<path d="M16 6a1.5 1.5 0 1 0 0 3 1.5 1.5 0 0 0 0-3Zm-2.45 1a2.5 2.5 0 0 1 4.9 0H21v1h-2.55a2.5 2.5 0 0 1-4.9 0H3V7h10.55ZM8 15a1.5 1.5 0 1 0 0 3 1.5 1.5 0 0 0 0-3Zm-2.45 1a2.5 2.5 0 0 1 4.9 0H21v1H10.45a2.5 2.5 0 0 1-4.9 0H3v-1h2.55Z"></path>' +
          '</svg>' +
          '<span>' + esc(T('rv_show_filter', 'Visa filter')) + (filterCount ? ' (' + filterCount + ')' : '') + '</span>' +
        '</button>';
    }
  }

  function render(d, append) {
    state.data = d;
    state.total = d.stats.shown_total;
    renderAside(d);

    var html = d.reviews.map(reviewHtml).join('');
    if (append) listEl.insertAdjacentHTML('beforeend', html);
    else listEl.innerHTML = html || '<p class="sr26-rv__empty">' + esc(T('rv_no_match', 'Inga recensioner matchar filtret.')) + '</p>';

    var shown = Math.min(state.page * PER, state.total);
    moreEl.hidden = !d.has_more && shown >= state.total;
    moreBtn.hidden = !d.has_more;
    moreBtn.textContent = T('rv_show_more', 'Visa fler recensioner');
    countEl.textContent = T('rv_showing', 'Visar {{ x }} av {{ y }}', { x: shown, y: state.total });
  }

  function load(append) {
    if (state.loading) return;
    state.loading = true;
    if (moreBtn) moreBtn.disabled = true;

    fetch(API + '/reviews?' + params())
      .then(function (r) { return r.json(); })
      .then(function (d) {
        if (d.error) throw new Error(d.error);
        render(d, append);
      })
      .catch(function () {
        // Går workern ned ska sektionen försvinna, inte visa ett tomt skal.
        SEC.hidden = true;
      })
      .finally(function () {
        state.loading = false;
        if (moreBtn) moreBtn.disabled = false;
      });
  }

  function toggle(bucket, id, value) {
    var set = bucket[id] || [];
    var v = value.toLowerCase();
    var i = set.indexOf(v);
    if (i === -1) set.push(v);
    else set.splice(i, 1);
    if (set.length) bucket[id] = set;
    else delete bucket[id];
  }

  // Temats egen öppningssekvens, kopierad från hur theme.js öppnar sök- och
  // kontaktdrawern: display först, .show på nästa frame så transitionen har
  // ett utgångsläge att animera FRÅN, .shadow när panelen är framme.
  // Stängningen rör vi inte — <close-drawer> i magnet.js lyssnar redan på
  // både krysset och .close-fullwidth och tar hand om scroll-låset.
  function openFilterDrawer() {
    var drawer = SEC.querySelector('[data-rv-aside-wrap]');
    if (!drawer) return;
    drawer.style.display = 'flex';
    requestAnimationFrame(function () {
      drawer.classList.add('show');
      setTimeout(function () { drawer.classList.add('shadow'); }, 400);
    });
    if (window.themeDrawerLock && typeof window.themeDrawerLock.lock === 'function') {
      window.themeDrawerLock.lock();
    }
  }

  SEC.addEventListener('click', function (e) {
    var chip = e.target.closest('[data-rv-chip]');
    if (chip) {
      var bucket = chip.dataset.rvChip === 'sub' ? state.subs : state.attrs;
      toggle(bucket, chip.dataset.id, chip.dataset.value);
      state.page = 1;
      return load(false);
    }
    if (e.target.closest('[data-rv-filter-open]')) {
      openFilterDrawer();
      return;
    }
    if (e.target.closest('[data-rv-clear]')) {
      state.attrs = {}; state.subs = {}; state.minRating = 1; state.page = 1;
      return load(false);
    }
    if (e.target.closest('[data-rv-more-btn]')) {
      state.page += 1;
      return load(true);
    }
  });

  // Spaken: `input` följer tummen live (text + fyllnad, ingen fetch),
  // `change` — när kunden släpper — filtrerar på riktigt.
  SEC.addEventListener('input', function (e) {
    var slider = e.target.closest('[data-rv-minrating]');
    if (!slider) return;
    var v = parseInt(slider.value, 10) || 1;
    slider.style.setProperty('--pct', ((v - 1) / 4) * 100 + '%');
    var label = SEC.querySelector('[data-rv-rating-value]');
    if (label) label.textContent = v > 1 ? 'Minst ' + '★'.repeat(v) : 'Alla';
  });

  SEC.addEventListener('change', function (e) {
    var sel = e.target.closest('[data-rv-sort-select]');
    if (sel) {
      state.sort = sel.value;
      state.page = 1;
      return load(false);
    }
    var slider = e.target.closest('[data-rv-minrating]');
    if (!slider) return;
    state.minRating = parseInt(slider.value, 10) || 1;
    state.page = 1;
    load(false);
  });

  // Två utlösare, den som kommer först vinner.
  //
  //   · Sektionen närmar sig — recensionerna ligger långt ned och ska inte
  //     konkurrera med köpkolumnen om bandbredden.
  //   · Sidan har laddat klart och webbläsaren är sysslolös. Behövs för att
  //     samma svar bär andelen fyra- och femstjärniga till teasern HÖGT upp
  //     på sidan. Väntade vi bara på scroll skulle den raden i praktiken
  //     alltid visa fallbackvärdet: kunden läser den långt innan hen är
  //     nere vid recensionerna.
  //
  // Anropet är detsamma i båda fallen och load() vaktar mot dubbelkörning,
  // så den tidiga hämtningen kostar ingen extra runda — den flyttar bara
  // den som ändå skulle ske.
  var started = false;
  function start() {
    if (started) return;
    started = true;
    load(false);
  }

  if ('IntersectionObserver' in window) {
    var io = new IntersectionObserver(function (entries) {
      if (entries[0].isIntersecting) { io.disconnect(); start(); }
    }, { rootMargin: '600px' });
    io.observe(SEC);
  }

  function whenIdle() {
    if (window.requestIdleCallback) requestIdleCallback(start, { timeout: 3000 });
    else setTimeout(start, 1200);
  }
  if (document.readyState === 'complete') whenIdle();
  else window.addEventListener('load', whenIdle, { once: true });
})();
